<template>
  <md-menu v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </md-menu>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

